import React from "react";
import {Card, Col, Row, Tag} from "antd";
import {useMemo, useEffect} from "react";
import {statusColors} from "../constants";

import { useSelector} from "react-redux";
import { selectPo} from "../../../redux/slices/purchassingOrder";
import { MoreOutlined } from '@ant-design/icons';
import { DownOutlined, SmileOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import Actions from "./Actions";
//import Button from '@mui/material/Button';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import { FaBars } from 'react-icons/fa';

export default function PurchaseCartCard({onClick, item}) {


    

    const {list } = useSelector(selectPo);
    

    const {ref, VendorName, CreatedBy, CreateAt} = item

  



    
    const handleClick = () => {
      alert(VendorName,)

        console.log('hi')
        onClick && onClick()
    }    

    return (
      
      <>
          

      
      <Col className='m-2'>
          
      <Card
        style={{ width: 400, cursor: "pointer", boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" }}
        // onClick={handleClick} 
        //Uncomment if intended to be used
      >
        <Row>
          <Col>
            <Row>
              <h5 className='text-truncate mb-2' style={{ width: 240 }}>
                {`${VendorName}`}
              </h5>
            </Row>
          </Col>

          <Col className='ml-auto'>
            {/* <Actions allproducts= {handleClick}/> */}
            <Dropdown>
                            <Dropdown.Toggle as={CustomToggle} id="dropdown-split-basic">
                                {/* <FaBars /> */}
                                <MoreOutlined style={{ fontSize: '25px' }} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu align="top" style={{ overflowY: "auto", maxHeight: "500px",width: "350px",height:"250px",borderRadius:"25px" }}>
                                <div style={{ borderColor: "red", borderWidth: 4, display: "inline" }}>
                                 {/*  <div> */}
                                  <Button variant="contained" color="" disableElevation style={{ margin: "5px", fontSize: "20px", fontWeight: "10", fontFamily: "Poppins",backgroundColor:"blue",color:"white",width:"100px",borderRadius:"25px"}} onClick={handleClick}>
                                        All
                                    </Button>
                                    <Button variant="contained" disableElevation style={{ margin: "5px", fontSize: "20px", fontWeight: "10", fontFamily: "Poppins",backgroundColor:"blue",color:"white",width:"100px",borderRadius:"25px" }}>
                                        Urgent
                                    </Button>
                                  {/* </div> */}
                                </div>
                                <div style={{ borderColor: "red", borderWidth: 4}}>
                                 {/*  <div> */}
                                  <Button variant="contained" color="" disableElevation style={{ margin: "5px", fontSize: "20px", fontWeight: "10", fontFamily: "Poppins",backgroundColor:"#53c685",color:"white",width:"100px",borderRadius:"25px"}}>
                                        {item.Show}
                                    </Button>
                                    <Button title="Urgent cart" variant="contained" disableElevation style={{ margin: "5px", fontSize: "20px", fontWeight: "10", fontFamily: "Poppins",backgroundColor:"orange",color:"white",width:"100px",borderRadius:"25px" }}>
                                        {item.Urgents}
                                    </Button>
                                    <Button title="Hide or show Validation cart" variant="contained" disableElevation style={{ margin: "5px", fontSize: "20px", fontWeight: "10", fontFamily: "Poppins",backgroundColor:"red",color:"white",width:"100px",borderRadius:"25px" }}>
                                        {item.Validation}
                                    </Button>
                                  {/* </div> */}
                                </div>
                                <div style={{ borderColor: "red", borderWidth: 4}}>
                                 {/*  <div> */}
                                  <Button variant="contained" color="" disableElevation style={{ margin: "5px", fontSize: "20px", fontWeight: "10", fontFamily: "Poppins",backgroundColor:"blue",color:"white",width:"100px",borderRadius:"25px"}}>
                                        Note
                                  </Button>
                                  <Button variant="contained" color="" disableElevation style={{ margin: "5px", fontSize: "20px", fontWeight: "10", fontFamily: "Poppins",backgroundColor:"#53c685",color:"white",borderRadius:"25px"}}>
                                        Full carts
                                  </Button>
                                    
                                </div>
                                <div style={{ borderColor: "red", borderWidth: 4}}>
                                 {/*  <div> */}
                                  <Button variant="contained" color="" disableElevation style={{ margin: "5px", fontSize: "20px", fontWeight: "10", fontFamily: "Poppins",backgroundColor:"#53c685",color:"white",borderRadius:"25px"}}>
                                        Validation
                                    </Button>
                                    
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>

            <div style={{ padding: '5px' }}></div>

            {/* Commented-out code */}
            {/* <Row>
              <Tag color={statusColors(status)}>{status}</Tag>
            </Row> */}

            <Row className='mt-4'>
              <Tag color='green'></Tag>
            </Row>

            <Row className='mt-3'>
              <p className='text-muted'>{CreatedBy}</p>
            </Row>
          </Col>
        </Row>
      </Card>
    </Col>
    </>
    )
}

// CustomToggle component
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <Button
      ref={ref}
      onClick={(e) => {
          e.preventDefault();
          onClick(e);
      }}
  >
      {children}
  </Button>
));

